import { IBaseFilterParameter, BaseFilterParameter } from "../base-filter.parameter";

export interface IReceptionParameter extends IBaseFilterParameter {
  block?: number[]
  creator?: number[]
  type?:string
}
export class ReceptionParameter extends BaseFilterParameter {
  block?: number[]
  creator?: number[]
  type?:string
  /**
   *
   */
  constructor(opt: IReceptionParameter = {}) {
    super({ state: opt.state });
    this.block = opt.block || [];
    this.creator = opt.creator || [];
    this.type = opt.type || null;
  }
}



// WEBPACK FOOTER //
// ./src/models/reception/reception.parameter.ts